import {takeEvery} from 'redux-saga/effects'
import {
  ADD_QUESTION,
  GET_ALL_QUESTIONS,
  GET_ALL_QUESTION_CATEGORIES,
  GET_QUESTION_SINGLE,
  UPDATE_QUESTION,
  // GET_FORM_SINGLE,
  // DELETE_SINGLE_TERM,
  // DELETE_MANY_TERMS,
  // LOCK_UNLOCK_TERMS,
} from 'setup/redux/Actions/Question/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ALL_QUESTION_CATEGORIES, fetchData)
  yield takeEvery(ADD_QUESTION, fetchData)
  yield takeEvery(GET_ALL_QUESTIONS, fetchData)
  yield takeEvery(GET_QUESTION_SINGLE, fetchData)
  yield takeEvery(UPDATE_QUESTION, fetchData)
  // yield takeEvery(GET_FORM_SINGLE, fetchData)
  // yield takeEvery(LOCK_UNLOCK_TERMS, fetchData)
}

export default dataSaga
